import React, { useState } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import './SubmenuInformatique.css';
import { HashLink } from 'react-router-hash-link';

const SubMenuLogiciel = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [submenuOpen, setSubmenuOpen] = useState(false);

    const isHashActive = (hash) => location.hash === hash;

    return (
        <div 
            className="navlink_with_submenu"
            onMouseEnter={() => setSubmenuOpen(true)}
            onMouseLeave={() => setSubmenuOpen(false)}
        >
            <NavLink
                to="/logiciel"
                className={({ isActive }) => (isActive ? "active" : "")}
                aria-haspopup="true"
                aria-expanded={submenuOpen}
            >
                Logiciel
            </NavLink>

            <div className={`submenu submenulog ${submenuOpen ? 'open' : ''}`}>
                <div className="navlink_description">
                    <h3>Logiciels Professionnels</h3>
                    <p>Solutions complètes pour l'installation, la configuration et la maintenance de vos outils métiers : Office 365, EBP et Windows.</p>
                    <button className="submenu_button" onClick={() => { navigate("/logiciel"); setSubmenuOpen(false); }}>
                        EN SAVOIR PLUS
                    </button>
                </div>

                <div className="navlink_menu">
                    <HashLink smooth to="/logiciel#Office" className={isHashActive("#Office") ? "active" : ""} onClick={() => setSubmenuOpen(false)}>Office 365</HashLink>
                    <HashLink smooth to="/logiciel#EBP" className={isHashActive("#EBP") ? "active" : ""} onClick={() => setSubmenuOpen(false)}>EBP</HashLink>
                    <HashLink smooth to="/logiciel#Windows" className={isHashActive("#Windows") ? "active" : ""} onClick={() => setSubmenuOpen(false)}>Microsoft Windows</HashLink>
                    <HashLink smooth to="/logiciel#Zeendoc" className={isHashActive("#Zeendoc") ? "active" : ""} onClick={() => setSubmenuOpen(false)}>Zeendoc</HashLink>
                    <HashLink smooth to="/logiciel#Nocrm" className={isHashActive("#Nocrm") ? "active" : ""} onClick={() => setSubmenuOpen(false)}>Nocrm</HashLink>
                </div>
            </div>
        </div>
    );
};

export default SubMenuLogiciel;